export const METER_FIELDS = [
    { label: 'Voltage R', aliases: ['vr', 'v r', 'voltage r', 'r phase voltage'], get: (d) => d.vpn?.V_R },
    { label: 'Voltage Y', aliases: ['vy', 'v y', 'voltage y', 'y phase voltage'], get: (d) => d.vpn?.V_Y },
    { label: 'Voltage B', aliases: ['vb', 'v b', 'voltage b', 'b phase voltage'], get: (d) => d.vpn?.V_B },
    { label: 'Average Voltage', aliases: ['v avg', 'avg voltage', 'voltage avg', 'average voltage', 'voltage'], get: (d) => d.vpn?.VLN_Avg },
    { label: 'Voltage RY', aliases: ['vry', 'voltage ry'], get: (d) => d.vpp?.V_RY },
    { label: 'Voltage YB', aliases: ['vyb', 'voltage yb'], get: (d) => d.vpp?.V_YB },
    { label: 'Voltage BR', aliases: ['vbr', 'voltage br'], get: (d) => d.vpp?.V_BR },
    { label: 'Average Line Voltage', aliases: ['vll avg', 'avg line voltage', 'line voltage avg', 'average line voltage'], get: (d) => d.vpp?.VLL_Avg },
    { label: 'Current R', aliases: ['ir', 'i r', 'current r', 'r phase current'], get: (d) => d.iavg?.Cu_R },
    { label: 'Current Y', aliases: ['iy', 'i y', 'current y', 'y phase current'], get: (d) => d.iavg?.Cu_Y },
    { label: 'Current B', aliases: ['ib', 'i b', 'current b', 'b phase current'], get: (d) => d.iavg?.Cu_B },
    { label: 'Total Current', aliases: ['total current', 'current total', 'current'], get: (d) => d.iavg?.Cu_Avg },
    { label: 'Power Factor', aliases: ['pf', 'power factor', 'pf avg', 'avg power factor'], get: (d) => d.pf_avg },
    { label: 'Power Factor Total', aliases: ['pf total', 'power factor total'], get: (d) => d.PF?.Total },
    { label: 'Power Factor R', aliases: ['pf r', 'power factor r'], get: (d) => d.PF?.R },
    { label: 'Power Factor Y', aliases: ['pf y', 'power factor y'], get: (d) => d.PF?.Y },
    { label: 'Power Factor B', aliases: ['pf b', 'power factor b'], get: (d) => d.PF?.B },
    { label: 'Frequency', aliases: ['freq', 'frequency', 'hz'], get: (d) => d.freq },
    { label: 'Power (kW)', aliases: ['kw', 'power', 'active power', 'demand', 'load'], get: (d) => d.KW?.Total },
    { label: 'Power R (kW)', aliases: ['kw r', 'power r'], get: (d) => d.KW?.R },
    { label: 'Power Y (kW)', aliases: ['kw y', 'power y'], get: (d) => d.KW?.Y },
    { label: 'Power B (kW)', aliases: ['kw b', 'power b'], get: (d) => d.KW?.B },
    { label: 'Apparent Power (kVA)', aliases: ['kva', 'apparent power'], get: (d) => d.KVA?.Total },
    { label: 'Apparent Power R (kVA)', aliases: ['kva r', 'apparent power r'], get: (d) => d.KVA?.R },
    { label: 'Apparent Power Y (kVA)', aliases: ['kva y', 'apparent power y'], get: (d) => d.KVA?.Y },
    { label: 'Apparent Power B (kVA)', aliases: ['kva b', 'apparent power b'], get: (d) => d.KVA?.B },
    { label: 'Total Energy (kWh)', aliases: ['total kwh', 'total energy', 'kwh', 'energy', 'consumption'], get: (d) => d.details?.wh_unit },
    { label: 'Voltage THD R', aliases: ['vthd r', 'voltage thd r', 'v harmonics r'], get: (d) => d.VTHD?.VHar_R },
    { label: 'Voltage THD Y', aliases: ['vthd y', 'voltage thd y', 'v harmonics y'], get: (d) => d.VTHD?.VHar_Y },
    { label: 'Voltage THD B', aliases: ['vthd b', 'voltage thd b', 'v harmonics b'], get: (d) => d.VTHD?.VHar_B },
    { label: 'Voltage THD Avg', aliases: ['vthd avg', 'vthd', 'voltage thd average', 'voltage thd'], get: (d) => d.VTHD?.VTHD_Avg },
    { label: 'Current THD R', aliases: ['ithd r', 'current thd r', 'i harmonics r'], get: (d) => d.ITHD?.CuHar_R },
    { label: 'Current THD Y', aliases: ['ithd y', 'current thd y', 'i harmonics y'], get: (d) => d.ITHD?.CuHar_Y },
    { label: 'Current THD B', aliases: ['ithd b', 'current thd b', 'i harmonics b'], get: (d) => d.ITHD?.CuHar_B },
    { label: 'Current THD Avg', aliases: ['ithd avg', 'ithd', 'current thd average', 'current thd'], get: (d) => d.ITHD?.ITHD_Avg },
];

const normalize = (s) => (s || '').toLowerCase().trim();
const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function matchMeterField(title) {
    const t = normalize(title);
    if (!t) return null;
    let best = null;
    METER_FIELDS.forEach((field) => {
        [field.label, ...field.aliases].forEach((raw) => {
            const candidate = normalize(raw);
            if (!candidate) return;
            const re = new RegExp(`\\b${escapeRegex(candidate)}\\b`, 'i');
            if (re.test(t) && (!best || candidate.length > best.len)) {
                best = { field, len: candidate.length };
            }
        });
    });
    return best ? best.field : null;
}
